import React, { forwardRef } from 'react';

import { SelectionType, VerticalPosition, HorizontalPosition, POSITIONS } from './constants';
import styles from './DropDownResults.module.css';
import { SelectedItem, MultiSelectDropDownOption } from './types';
import FlatOptions from './FlatOptions';
import GroupedOptions from './GroupedOptions';

interface DropDownResultsProps {
  options: MultiSelectDropDownOption[] | Record<string, MultiSelectDropDownOption[]>;
  selectedItems: SelectedItem[];
  onItemSelect: (value: string, group?: string, type?: SelectionType, label?: string) => void;
  isMapOptions: boolean;
  verticalPosition?: VerticalPosition;
  horizontalPosition?: HorizontalPosition;
  focusedIndex?: number;
  id?: string;
  role?: string;
}

const DropDownResults = forwardRef<HTMLDivElement, DropDownResultsProps>(
  (
    {
      options,
      selectedItems,
      onItemSelect,
      isMapOptions,
      verticalPosition = POSITIONS.VERTICAL.DOWN,
      horizontalPosition = POSITIONS.HORIZONTAL.LEFT,
      focusedIndex = -1,
      id,
      role,
    },
    ref,
  ) => {
    const getContainerClasses = () => {
      return `${styles.resultsContainer} ${
        verticalPosition === POSITIONS.VERTICAL.UP ? styles.positionUp : styles.positionDown
      } ${horizontalPosition === POSITIONS.HORIZONTAL.RIGHT ? styles.positionRight : styles.positionLeft}`;
    };

    return (
      <div ref={ref} className={getContainerClasses()} id={id} role={role}>
        {isMapOptions ? (
          <GroupedOptions
            options={options as Record<string, MultiSelectDropDownOption[]>}
            selectedItems={selectedItems}
            onItemSelect={onItemSelect}
            focusedIndex={focusedIndex}
          />
        ) : (
          <FlatOptions
            options={options as MultiSelectDropDownOption[]}
            selectedItems={selectedItems}
            onItemSelect={onItemSelect}
            focusedIndex={focusedIndex}
          />
        )}
      </div>
    );
  },
);

DropDownResults.displayName = 'DropDownResults';

export default DropDownResults;
